const initialState = {
  hasFetched: false,
  data: {},
  fetchError: null,
  updateError: null,
  isPatching: false
};

export default function listingPricing (state = initialState, action) {
  const {
    data,
    fetchError,
    type,
    updateError,
    isPatching
  } = action;

  if ('LISTING_PRICING_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('LISTING_PRICING_FETCH_REQUEST' === type) {
    return { ...state };
  }

  if ('LISTING_PRICING_FETCH_SUCCESS' === type) {
    return { ...state, data, hasFetched: true };
  }

  if ('LISTING_PRICING_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true };
  }

  if ('PRICE_UPDATE_REQUEST' === type) {
    return { ...state, isPatching };
  }

  if ('PRICE_UPDATE_SUCCESS' === type) {
    return { ...state, isPatching };
  }

  if ('PRICE_UPDATE_FAILURE' === type) {
    return { ...state, updateError, isPatching };
  }

  return state;
}
